import { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';

/**
 * Back to top button component
 * Appears after scrolling down 500px for better long-page navigation
 * Follows WCAG 2.1 AA keyboard navigation standards
 */
const BackToTop = ({ scrollThreshold = 500 }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.scrollY > scrollThreshold);
    };

    // Initial check
    toggleVisibility();

    window.addEventListener('scroll', toggleVisibility, { passive: true });
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, [scrollThreshold]);

  const scrollToTop = () => {
    window.scrollTo({ 
      top: 0, 
      behavior: 'smooth' 
    });
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      scrollToTop();
    }
  };

  return (
    <button
      type="button"
      onClick={scrollToTop}
      onKeyDown={handleKeyDown}
      aria-label="Back to top"
      className={`fixed bottom-8 right-8 z-40 p-3 bg-teal text-white rounded-full shadow-lg transition-all duration-300 hover:bg-teal/90 hover:scale-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal focus-visible:ring-offset-2 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
      tabIndex={isVisible ? 0 : -1}
    >
      <ArrowUp size={20} aria-hidden="true" />
    </button>
  );
};

export default BackToTop;
